import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { FrozenCardLink } from 'components/cash/FrozenCardLink/FrozenCardLink';
import { Button } from 'components/form/Button/index';
import Label from 'components/form/Label/Label';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getFundCashUI } from 'pages/Cash/helpers/cashHelpers';
import { useEffect } from 'react';
import './CashFundAccountModule.scss';

const CashFundAccountCTA = ({
  showPinCTA,
  handleHowToTransferModal,
  handleTransferBalanceModal,
  handleSetPinClick,
  datatestid,
  frozenCard,
}) => {
  return (
    <FlexContainer className="flex-tablet-col">
      {showPinCTA ? (
        <Button
          datatestid={`${datatestid}-setPin`}
          onClick={handleSetPinClick}
          neverFullWidth
          disabled={frozenCard}
          mrphType="primary"
        >
          Set Card PIN
        </Button>
      ) : (
        <FlexContainer className="flex-tablet-col transfer-cta-container">
          <Button
            datatestid={`${datatestid}-transferMoney`}
            onClick={() =>
              handleTransferBalanceModal({
                type: 'moveMoney',
              })
            }
            neverFullWidth
            mrphType="primary"
          >
            Add Money
          </Button>
          <div className="padR12 mobileHide" />
          <div className="padB12 desktopHide" />
          <Button
            datatestid={`${datatestid}-howToTransferMoney`}
            onClick={handleHowToTransferModal}
            neverFullWidth
            mrphType="standard"
          >
            How to Add Money
          </Button>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export const PinSetSuccessMessage = ({
  handleHidePinSuccessMessage,
  datatestid,
}) => {
  useEffect(() => {
    if (typeof handleHidePinSuccessMessage === 'function') {
      handleHidePinSuccessMessage();
    }
    //eslint-disable-next-line
  }, []);
  return (
    <FlexContainer className="PinSetSuccessMessage padTB28 flex-column align-items-center">
      <div
        data-testid={`${datatestid}-accountSetupSuccessImage`}
        className="congratulations-image"
      />
      <div className="padB24" />
      <Label
        datatestid={`${datatestid}-accountSetupSuccessTitle`}
        className="bold"
      >
        Congratulations!
      </Label>
      <Label
        datatestid={`${datatestid}-accountSetupSuccessDescription`}
        className="bold"
      >
        Your account is all set
      </Label>
      <div className="padB48 mobileHide" />
    </FlexContainer>
  );
};

export const CashFundAccountModule = ({
  handleTransferBalanceModal,
  handleHowToTransferModal,
  handleSetPinClick,
  pinSet,
  hidePinSuccessMessage,
  handleHidePinSuccessMessage,
  modulePosition,
  frozenCard,
  ...props
}) => {
  const {
    fundAccountTitle,
    fundAccountMessage,
    showPinCTA,
    imageClass,
    moduleName,
  } = getFundCashUI(props.sesameCashAccount);

  const mobileImageClass = classnames(imageClass, 'm-format100');
  const desktopImageClass = classnames(imageClass, 'format100');
  const datatestid = 'cashFundAccount';

  const pixel = useSeenModulePixel(
    getViewModuleTrackingAttributes(moduleName, modulePosition, moduleName),
  );

  if (hidePinSuccessMessage) {
    return <></>;
  }

  if (pinSet) {
    return (
      <FlexContainer className="margLRAuto">
        {pixel}
        <PinSetSuccessMessage
          datatestid={datatestid}
          handleHidePinSuccessMessage={handleHidePinSuccessMessage}
        />
      </FlexContainer>
    );
  }

  return (
    <SectionContainer
      datatestid={datatestid}
      className={classnames({ frozenCard: frozenCard })}
    >
      {pixel}
      <Row datatestid={datatestid}>
        {frozenCard && showPinCTA && (
          <div className="margB16">
            <FrozenCardLink additionalCopy="Un-freeze to set PIN" />
          </div>
        )}
        <FlexContainer className="justify-between">
          <FlexContainer className="flex-column m-format100 mobile-justify-center">
            <div className="padB8" />
            <Label
              datatestid={`${datatestid}-title`}
              typeHeader={'h3'}
              className="H3 mH5"
            >
              {fundAccountTitle}
            </Label>
            <div className="padB16" />
            <Label datatestid={`${datatestid}-message`}>
              {fundAccountMessage}
            </Label>
            <div className="padB32 mobileHide" />
            <FlexContainer className="flex-container desktopOnlyHide tabletShow format100 flex-column align-items-center">
              <div className="padB16" />
              <div
                data-testid={`${datatestid}-mobile-image`}
                className={mobileImageClass}
              ></div>
              <div className="padB16" />
            </FlexContainer>
            <CashFundAccountCTA
              showPinCTA={showPinCTA}
              handleHowToTransferModal={handleHowToTransferModal}
              handleTransferBalanceModal={handleTransferBalanceModal}
              handleSetPinClick={handleSetPinClick}
              datatestid={datatestid}
              frozenCard={frozenCard}
            />
          </FlexContainer>
          <FlexContainer className="mobileHide">
            <div
              data-testid={`${datatestid}-desktop-image`}
              className={desktopImageClass}
            ></div>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
